import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Home from './components/home/Main'
import About from './components/about/Main.vue'
import KcmGroup from './components/kcmGroup/Main.vue'
import Products from './components/products/Main.vue'
import Sustainability from './components/sustainability/Main.vue'
import Careers from './components/careers/Main.vue'
// import Signal from './components/shared/Signal.vue'
import News from './components/news/Main.vue'
import Contacts from './components/contacts/Main.vue'
import LifeRecad from './components/lifeRecad/Main.vue'
import Styles from './components/Styles'
import Administration from './components/administration/Administration'
import AdministrationNews from './components/administration/news/News'
import AdministrationJob from './components/administration/Job'
import Login from './components/administration/Login'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    // {
    //   path: '/signal',
    //   name: 'Signal',
    //   component: Signal
    // },
    {
      path: '/kcm-group',
      name: 'kcmGroup',
      component: KcmGroup
    },
    {
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      path: '/sustainability',
      name: 'sustainability',
      component: Sustainability
    },
    {
      path: '/careers',
      name: 'careers',
      component: Careers
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: Contacts
    },
    {
      path: '/life-recad',
      name: 'lifeRecad',
      component: LifeRecad
    },
    // STYLES FOR DEVELOPMENT
    {
      path: '/styles',
      name: 'styles',
      component: Styles
    },
    // ADMINISTRATION
    {
      path: '/administration/login',
      name: 'administrationLogin',
      component: Login
    },
    {
      path: '/administration',
      name: 'administration',
      component: Administration,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/administration/news',
      name: 'administrationNews',
      component: AdministrationNews,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/administration/job',
      name: 'administrationJob',
      component: AdministrationJob,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/administration/job/:id',
      name: 'administrationJobEdit',
      component: AdministrationJob,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return;
    }
    next({
      path: '/administration/login'
    });
  } else {
    next();
  }
})


export default router